import script from "./ButtonClipboardCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonClipboardCopy.vue?vue&type=script&setup=true&lang=js"

export default script